import { DesignTypeEnum } from '../../../enum/design-type.enum';

export function addBlockDesignObjectType(blockDataModel: any, designObjectType: DesignTypeEnum) {
  if (!blockDataModel._availableBlocks) {
    blockDataModel._availableBlocks = [];
  }
  blockDataModel._availableBlocks.push(designObjectType);
  return blockDataModel;
}
